import { NgModule } from "@angular/core";
import { HttpClient } from "@angular/common/http";
import { ContentProviderAdapter } from "./content-provider.interface";
import { CONTENT_PROVIDER } from "./content-provider.token";
import { GhostContentAdapter } from "../adapters/ghost-content.adapter";

/**
 * Provider factory - creates the appropriate content adapter
 * Currently returns Ghost adapter. To add new providers:
 * 1. Implement new adapter (e.g., ContentfulAdapter)
 * 2. Update factory to return new adapter based on config
 */
export function providerFactory(http: HttpClient): ContentProviderAdapter {
  return new GhostContentAdapter(http);
}

/**
 * Learn Content Module
 *
 * Provides DI configuration for the content provider infrastructure.
 * Supplies only the content adapter (CONTENT_PROVIDER token).
 */
@NgModule({
  providers: [
    {
      provide: CONTENT_PROVIDER,
      useFactory: providerFactory,
      deps: [HttpClient],
    },
  ],
})
export class LearnContentModule {}
